import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adm, apiErr } from "../../lib/adminApi";
import { PageHead, TInput, Toggle, Btn, Card, Badge } from "../../components/admin/ui";
import { money } from "../../lib/api";

export default function AdminInnerCircle() {
  const [settings, setSettings] = useState(null);
  const [members, setMembers] = useState([]);
  const [subs, setSubs] = useState([]);
  useEffect(() => {
    adm.settings().then(setSettings).catch(() => {});
    adm.members().then(setMembers).catch(() => {});
    adm.subscribers().then(setSubs).catch(() => {});
  }, []);
  if (!settings) return <p className="text-white/40 font-mono text-xs">LOADING…</p>;

  const setPlan = (i, k, v) => setSettings((s) => ({
    ...s, membershipPlans: s.membershipPlans.map((p, idx) => (idx === i ? { ...p, [k]: v } : p)) }));

  const save = async () => {
    try {
      await adm.saveSettings({
        membershipPlans: settings.membershipPlans,
        memberDiscountPercent: Number(settings.memberDiscountPercent) || 0,
        allowDiscountStacking: !!settings.allowDiscountStacking,
      });
      toast.success("Membership settings saved. Existing subscribers keep their original price.");
    } catch (e) { toast.error(apiErr(e)); }
  };

  const paidMembers = members.filter((m) => m.membershipStatus === "active");

  return (
    <div data-testid="admin-inner-circle">
      <PageHead title="Inner Circle" sub="Paid membership — completely separate from the free mailing list. Price changes never affect existing subscribers automatically.">
        <Btn onClick={save} testid="ic-save">SAVE SETTINGS</Btn>
      </PageHead>

      <Card>
        <p className="font-mono text-[10px] tracking-[0.3em] text-gold mb-4">MEMBERSHIP PLANS</p>
        {settings.membershipPlans?.map((p, i) => (
          <div key={p.planKey} className="grid md:grid-cols-4 gap-4 items-end border-t border-white/5 py-4">
            <TInput label="NAME" value={p.name} onChange={(v) => setPlan(i, "name", v)} testid={`plan-${p.planKey}-name`} />
            <TInput label="PRICE (CENTS / MONTH)" value={p.price} onChange={(v) => setPlan(i, "price", Number(v) || 0)} type="number" testid={`plan-${p.planKey}-price`} />
            <div className="font-mono text-[9px] text-white/40 pb-3">{p.lookupKey} · {money(p.price, p.currency)}/mo</div>
            <div className="pb-2"><Toggle label="ACTIVE (JOINABLE)" checked={!!p.active} onChange={(v) => setPlan(i, "active", v)} testid={`plan-${p.planKey}-active`} /></div>
          </div>
        ))}
        <div className="grid md:grid-cols-3 gap-4 items-end border-t border-white/10 pt-5 mt-2">
          <TInput label="MEMBER DISCOUNT % (ELIGIBLE PRODUCTS)" value={settings.memberDiscountPercent}
            onChange={(v) => setSettings((s) => ({ ...s, memberDiscountPercent: v }))} type="number" testid="ic-discount" />
          <div className="pb-2"><Toggle label="ALLOW DISCOUNT STACKING" checked={!!settings.allowDiscountStacking}
            onChange={(v) => setSettings((s) => ({ ...s, allowDiscountStacking: v }))} /></div>
        </div>
      </Card>

      <div className="grid lg:grid-cols-2 gap-6 mt-8">
        <Card>
          <p className="font-mono text-[10px] tracking-[0.3em] text-gold mb-4">MEMBERS ({members.length}) — ACTIVE INNER CIRCLE: {paidMembers.length}</p>
          <div className="max-h-96 overflow-y-auto">
            {members.map((m) => (
              <div key={m.id} className="flex items-center justify-between py-2.5 border-t border-white/5 gap-3">
                <div className="min-w-0">
                  <p className="text-xs text-white/80 truncate">{m.email}</p>
                  <p className="font-mono text-[8px] text-white/30">{m.role.toUpperCase()} · {m.emailVerified ? "VERIFIED" : "UNVERIFIED"} · {m.points} PTS</p>
                </div>
                <Badge tone={m.membershipStatus === "active" ? "gold" : "dim"}>{m.membershipStatus === "active" ? m.membershipPlan || "MEMBER" : "NO MEMBERSHIP"}</Badge>
              </div>
            ))}
          </div>
        </Card>
        <Card>
          <p className="font-mono text-[10px] tracking-[0.3em] text-gold mb-4">MAILING LIST SUBSCRIBERS ({subs.length}) — FREE, SEPARATE FROM INNER CIRCLE</p>
          <div className="max-h-96 overflow-y-auto">
            {subs.map((sub) => (
              <div key={sub.id} className="flex justify-between py-2.5 border-t border-white/5">
                <span className="text-xs text-white/80">{sub.firstName}</span>
                <span className="text-xs text-white/40">{sub.email}</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
